<template>
  <v-container class="py-0 px-0" fluid>
    <v-row>
      <v-row class="pr-3 pb-2" no-gutters>
        <v-col cols="12">
          <v-row justify="end" no-gutters>
            <v-col cols="auto">
              <mf-button
                v-if="
                  !isFranchise &&
                  ($getLoggedUser().has_club || ($getIsEcommerce() && userPermissions.includes('add_modelo')) || $getLoggedUser().has_mercapromo)
                "
                label="Criar produto"
                class="mr-3"
                data-cy="createProduct"
                @click="openCreateDialog()"
              />
            </v-col>
            <v-col cols="auto">
              <importar-produtos-dialog v-if="!isFranchise" class="pr-6" @success="getData()" />
            </v-col>
            <v-col cols="auto">
              <v-menu v-model="filterOpen" left offset-x :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-badge color="marca-1" :value="filtersQuantity" :content="filtersQuantity" overlap>
                    <mf-button color="cinza-0" icon="filter_list" type="icon" v-on:click.native="on.click" />
                  </v-badge>
                </template>

                <v-card width="285px">
                  <v-card-text>
                    <p class="title">Filtros</p>
                    <v-container class="px-0 py-0">
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="filters.active"
                            :items="[
                              { text: 'Ativos', val: true },
                              { text: 'Não ativo', val: false },
                              { text: 'Todos', val: 'Todos' },
                            ]"
                            label="Ativo"
                            hide-details
                            outlined
                            item-value="val"
                            item-text="text"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            v-model="filters.withImages"
                            :items="[
                              { text: 'Sim', val: true },
                              { text: 'Não', val: false },
                              { text: 'Todos', val: 'Todos' },
                            ]"
                            label="Com imagem"
                            hide-details
                            outlined
                            item-value="val"
                            item-text="text"
                          />
                        </v-col>
                        <v-col v-if="$getLoggedUser().has_club && $getIsEcommerce()" class="mt-n4" cols="12">
                          <v-row no-gutters justify="end">
                            <v-col cols="auto">
                              <mf-tooltip variant="secondary" top max-width="250">
                                <template v-slot:activator>
                                  <mf-icon size="17" class="mb-1">info</mf-icon>
                                </template>
                                <span>
                                  <ul>
                                    <li>Todos: Lista os produtos de ambas as plataformas</li>
                                    <li>CBM: Lista apenas os produtos da plataforma CBM</li>
                                    <li>E-commerce: Lista apenas os produtos da plataforma e-commerce</li>
                                  </ul>
                                </span>
                              </mf-tooltip>
                            </v-col>
                          </v-row>
                          <v-select
                            v-model="filters.products"
                            :items="[
                              { text: 'Todos', val: 'all' },
                              { text: 'CBM', val: 'cbm' },
                              { text: 'E-commerce', val: 'ecommerce' },
                            ]"
                            label="Plataforma"
                            hide-details
                            outlined
                            item-value="val"
                            item-text="text"
                          />
                          <v-select
                            v-model="filters.manuallyEdited"
                            :items="[
                              { text: 'Sim', val: true },
                              { text: 'Não', val: false },
                            ]"
                            label="Editado Manualmente"
                            hide-details
                            outlined
                            class="mt-5"
                            item-value="val"
                            item-text="text"
                          />
                          <v-select
                            v-model="filters.typeEan"
                            :items="[
                              { text: 'Apenas um EAN', val: 'ONE' },
                              { text: 'Múltiplos EANs', val: 'MULTIPLE' },
                              { text: 'Sem EAN', val: 'WITHOUT' },
                            ]"
                            label="Tipo de EAN"
                            hide-details
                            outlined
                            class="mt-5"
                            item-value="val"
                            item-text="text"
                          />
                        </v-col>
                        <v-col cols="12">
                          <search-categories ref="searchCategorias" v-model="filters" is-filter />
                        </v-col>
                      </v-row>
                    </v-container>
                    <mf-action-buttons
                      :primary-button="{
                        text: 'Aplicar',
                        action: applyFilters,
                        isVisible: true,
                      }"
                      :cancel-button="{
                        text: 'Limpar',
                        action: clearFilters,
                        isVisible: true,
                      }"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-card>
      <v-card-text>
        <gerenciamento-produto-tabela ref="productManager" :filters="filters" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import GerenciamentoProdutoTabela from '../components/GerenciamentoProdutoTabela.vue'
import orderBy from 'lodash/orderBy'
import { QUERY_GET_PRODUCTS, PRODUCT_CATEGORIES, PRODUCT_CATEGORIES_FINAL_CONSUMER } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  name: 'ProductList',
  components: {
    ImportarProdutosDialog: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/ImportarProdutosDialog.vue'),
    GerenciamentoProdutoTabela,
    SearchCategories: () => import('./createEditProduct/SearchCategories.vue'),
  },
  data: () => ({
    timeout: {},
    filterOpen: false,
    categoriesModal: false,
    filters: {
      search: '',
      withImages: 'Todos',
      active: 'Todos',
      cbm: 'Todos',
      ecommerce: 'Todos',
      departmentId: '',
      categoryId: '',
      products: 'all',
      manuallyEdited: null,
      typeEan: '',
    },
    options: {
      page: 1,
    },
    dialogSingleProduct: false,
    products: [],
    selectedProduct: {},
    isNewProduct: false,
    maxRecords: 1,
    paginationLoading: false,
    categories: [],
    filtersQuantity: 0,
    categoriesFilter: [],
    values: [],
    currentIndex: 0,
    hasNotDepartment: false,
    hasNotCategory: false,
  }),
  provide: function () {
    return {
      userHasPermission: true,
    }
  },
  computed: {
    isFranchise() {
      // franquia
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    userPermissions() {
      return this.$getLoggedUser().ecommercePermissions
    },
  },
  apollo: {
    categories: {
      query: PRODUCT_CATEGORIES,
      update({ productCategories }) {
        const categories = orderBy(productCategories, 'name')
        return categories
      },
    },
    categoriesFilter: {
      query: PRODUCT_CATEGORIES_FINAL_CONSUMER,
      variables() {
        return {
          search: '',
        }
      },
      update({ categoriesFinalConsumer }) {
        const categories = orderBy(categoriesFinalConsumer, 'name')
        return categories
      },
    },
  },
  watch: {
    options(value) {
      this.getData()
    },
    filters: {
      handler(filters) {
        this.filtersQuantity = 0

        if (filters.categoryId && filters.categoryId.length) {
          this.filtersQuantity++
        }

        if (filters.active !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.cbm !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.ecommerce !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.withImages !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.departmentId && filters.departmentId.length) {
          this.filtersQuantity++
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    formatDate(val) {
      return DateTime.fromISO(val).toFormat('dd/MM/yyyy')
    },
    applyFilters() {
      this.$refs.productManager.options.page = 1
      this.$refs.productManager.getData()
      this.filterOpen = false
    },
    openCategories() {
      this.categoriesModal = true
    },
    clearFilters() {
      this.filters.category = 'Todos'
      this.filters.active = 'Todos'
      this.filters.withImages = 'Todos'
      this.filters.products = 'all'
      this.filters.ecommerce = 'Todos'
      this.filters.departmentId = ''
      this.filters.categoryId = ''
      this.filtersQuantity = 0
      this.filters.manuallyEdited = null
      this.filters.typeEan = ''

      this.$refs.searchCategorias.clearCategories()

      this.$refs.productManager.getData()
    },
    openCreateDialog() {
      this.$router.push({ path: '/produtos/novo' })
    },
    openEditDialog(product) {
      this.selectedProduct = product
      this.isNewProduct = false
      this.dialogSingleProduct = true
    },
    filterBySearch(query) {
      clearTimeout(this.timeout)
      this.paginationLoading = true
      this.timeout = setTimeout(() => {
        this.options.page = 1
        this.getData()
      }, 1000)
    },
    async getData() {
      const filters = {
        categoryId: this.filters.categoryId,
        departmentId: this.filters.departmentId,
      }

      if (this.filters.active !== 'Todos') {
        filters.active = this.filters.active
      }

      if (this.filters.withImages !== 'Todos') {
        filters.withImages = this.filters.withImages
      }

      if (this.$getLoggedUser().has_club && this.$getIsEcommerce() && ['ecommerce', 'cbm'].includes(this.filters.products)) {
        filters.ecommerce = this.filters.products === 'ecommerce'
        filters.cbm = this.filters.products === 'cbm'
      }
      if (this.filters.manuallyEdited !== null) {
        filters.manuallyEdited = this.filters.manuallyEdited
      }
      if (this.filters.typeEan) {
        filters.eanEnum = this.filters.typeEan
      }

      try {
        this.paginationLoading = true
        const {
          data: {
            listProduct: { products, records },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_PRODUCTS,
          variables: {
            page: this.options.page || 1,
            pageSize: this.options.itemsPerPage || 15,
            search: this.filters.search,
            filter: filters,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        this.products = products
        this.maxRecords = records
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produtos', snackbarColor: 'error' })
      } finally {
        this.paginationLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}
</style>
